/**
 * @fileoverview Registry of agent tools (function-calling definitions backed by the
 * qwksearch API) that can be attached to agent prompts in prompt-templates.ts.
 *
 * Currently empty; populate with `AgentTool` entries (name, schema, func) as
 * qwksearch-backed tools are implemented.
 */

export const AGENT_TOOLS: any[] = [];
